import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { useAdminAuth } from '@/context/Admin';
import AdminDashboardSkeleton from '@/components/admin/AdminDashboardSkeleton';
import { useEffect, useRef } from 'react';

const ProtectedAdminRoute = () => {
  const authContext = useAdminAuth();
  const location = useLocation();
  const hasCheckedAuth = useRef(false);

  // Safety check: if context is undefined, redirect to login
  if (!authContext) {
    console.error('useAdminAuth returned undefined. AdminAuthProvider may not be properly set up.');
    return <Navigate to="/admin/login" replace />;
  }

  const { admin, loading, fetchAdmin } = authContext;

  // Check authentication on mount and when location changes
  // The fetchAdmin function now prevents concurrent calls internally
  useEffect(() => {
    if (fetchAdmin) {
      fetchAdmin();
      hasCheckedAuth.current = true;
    }
  }, [location.pathname, fetchAdmin]);

  // Show skeleton while checking authentication or if we haven't checked yet
  if (loading || !hasCheckedAuth.current) return <AdminDashboardSkeleton />;

  return admin ? <Outlet /> : <Navigate to="/admin/login" replace />;
};

export default ProtectedAdminRoute;
